import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-[var(--control-height-standard)] w-full min-w-0 rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-50)] bg-[var(--surface-panel-solid)] px-[var(--control-padding-x-tight)] py-0.5 text-sm leading-4 text-[var(--neutral-gray-120)] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[var(--neutral-gray-80)] focus-visible:outline-none focus-visible:border-[var(--azure-primary)] focus-visible:ring-2 focus-visible:ring-[var(--azure-focus-ring)] disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-[var(--neutral-gray-20)]",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
